import { IconMainMenuAnalytics } from "@suse-o11y/icons";
import React from "react";

import { Permission } from "~/models/dto";

import { usePermissions } from "../../common/use-permissions";
import { useNavigateToLink } from "../../components/react/link";
import { ANALYTICS_PATH } from "../../routes/Routes";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemAnalytics: React.FC = () => {
	const permissions = usePermissions();
	const link = useNavigateToLink(ANALYTICS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	if (!permissions?.hasSystemPermission(Permission.ExecuteScripts)) {
		return null;
	}

	return (
		<MainMenuItemLayout
			className="analyticsMenu"
			icon={<IconMainMenuAnalytics height={18} width={18} />}
			label="Analytics"
			to={link}
		/>
	);
};
